import { Container, makeStyles, Paper } from "@material-ui/core";

import { Cooperation } from "../../gardener/gardener.model";
import { LevelIconAndText } from "../your-level/LevelIconAndText";
import { determineLevelText, determineNextCooperationLevel } from "../utility";
import { BlockingProgressItemHeader } from "./BlockingProgressHeader";

const useStyles = makeStyles(theme => ({
    card: {
        overflow: "hidden",
        padding: "24px",

        "& > *": {
            marginBottom: "24px",

            "&:last-child": {
                marginBottom: 0,
            },
        },
    },
    paragraph: {
        fontSize: "16px",
        fontWeight: 400,
        color: "#4A4A4A",

        "& > span": {
            fontWeight: 600,
        },

        [theme.breakpoints.down(500)]: {
            textAlign: "center",
        },
    },
}));

interface LimitReachedItemProps {
    cooperationLevel: Exclude<Cooperation["level"], "platin">;
    tasksUntilNextLevel: number;
    onClose?: () => void;
}

export const LimitReachedItem = (props: LimitReachedItemProps) => {
    const classes = useStyles();
    const { cooperationLevel, tasksUntilNextLevel, onClose } = props;

    const levelText = determineLevelText(cooperationLevel);
    const nextCooperationLevel = determineNextCooperationLevel(cooperationLevel);

    return (
        <Container maxWidth="sm" disableGutters>
            <Paper className={classes.card}>

                <BlockingProgressItemHeader onClose={onClose}>
                    Du har nået din grænse ved <LevelIconAndText cooperationLevel={cooperationLevel} />
                </BlockingProgressItemHeader>

                <div className={classes.paragraph}>
                    Du har taget imod mange nye opgaver – det er fedt! 👍
                </div>

                <div className={classes.paragraph}>
                    Du har nået din grænse ved {levelText}, men vil blive tilbudt flere opgaver, efterhånden som du løser dem, du allerede har.
                </div>

                <div className={classes.paragraph}>
                    Løs <span>{tasksUntilNextLevel} {tasksUntilNextLevel !== 1 ? "opgaver" : "opgave"}</span> for
                    at nå <LevelIconAndText cooperationLevel={nextCooperationLevel} />
                </div>

            </Paper>
        </Container>
    );
};
